export default __webpack_public_path__ + "25fd35569642d7e2dbbc1a72f2ce3389.jpg";